import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getQRCodes = async (fleetCompanyId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/qr-codes/`,
      {
        params: fleetCompanyId ? { fleet_company_id: fleetCompanyId } : {},
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("QR codes fetch error:", error);
    throw error;
  }
};

const getQRFleetCompanies = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/qr-codes/fleet-companies/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("QR fleet companies fetch error:", error);
    throw error;
  }
};

const getQRCodeById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/qr-codes/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("QR code fetch error:", error);
    throw error;
  }
};

const revealQRCardNumber = async (id) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/qr-codes/reveal/?id=${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Card number reveal error:", error);
    throw error;
  }
};

const updateFuelCardStatus = async (id, status, reason) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-cards/status/?id=${id}`,
      reason ? { status, reason } : { status },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel card status update error:", error);
    throw error;
  }
};

const getFuelCards = async (fleetCompanyId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-cards/`,
      {
        params: fleetCompanyId ? { fleet_company_id: fleetCompanyId } : {},
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel cards fetch error:", error);
    throw error;
  }
};

const generateFuelCards = async (fleetCompanyId) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-cards/generate/`,
      { fleet_company_id: fleetCompanyId },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel card generate error:", error);
    throw error;
  }
};

export {
  getQRCodes,
  getQRCodeById,
  revealQRCardNumber,
  updateFuelCardStatus,
  getFuelCards,
  generateFuelCards,
  getQRFleetCompanies,
};
